var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"raw-params"},[_vm._l((_vm.chunks),function(c,i){return [(c.colorIndex === -1)?_c('span',{key:i},[_vm._v(_vm._s(c.text))]):_c('span',{key:i,class:'pspan-' + c.colorIndex},[_vm._v(_vm._s(c.text))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }